import { Button, styled, Typography } from '@mui/material';

export const PageTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (max-width: 1023px) {
    padding: 0px;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`;

export const PageW = styled('div')<{ isManager: boolean }>`
  width: 100%;
  padding-left: 38px;
  padding-top: 64px;
  @media (max-width: 1023px) {
    padding: 88px 16px 0px 16px;
    padding-bottom: 96px;
  }
`;

export const TopMenuW = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: top;
  width: 850px;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const StyledBtn = styled(Button)`
  position: relative;
  height: 100%;
  padding-left: 0;
  padding: 5px;
  min-width: unset;
  border-radius: 50%;
`;
